import React from 'react';
import { Edit2 } from 'react-feather';
import LESSON_STATES from 'constants/lesson_states';
import { routes } from 'constants/config';
import { Button } from 'ui';

const EditButtonText = ({ state }) => {
  switch (state) {
    case LESSON_STATES.PUBLISHED:
      return t('lesson_overview.actions.new_draft');
    case LESSON_STATES.CLASSIC:
      return t('lesson_overview.actions.update');
    case LESSON_STATES.DRAFT:
    case LESSON_STATES.NEW_VERSION_PENDING:
    default:
      return t('lesson_overview.actions.edit');
  }
};

const LessonEditButton = ({ lesson }) => {
  const isArchived = lesson.archivedAt !== null;

  return (
    !isArchived && (
      <Button
        className="d-f jc-c ws-nw mr-32"
        url={routes.LESSON_OVERVIEW.EDIT_LESSON(lesson.id)}
      >
        <span className="d-f ai-c">
          <Edit2 className="mr-8 c-midnight-50" size={16} />
          <span className="pl-8 pr-8">
            <EditButtonText state={lesson.state} />
          </span>
        </span>
      </Button>
    )
  );
};
export default props => <LessonEditButton {...props} />;
